/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.17",
  "buildId": "20260806-1420-573b579",
  "builtAt": "2026-08-06T08:51:07.856Z"
});
